export default {
  title: 'RFID EPC 流转报表',
  inputTypeEpc: 'RFID EPC',
  inputTypeQr: 'QR Code',
  inputPlaceholderEpc: '最多输入 10 个 EPC，用逗号分隔',
  inputPlaceholderQr: '最多输入 10 个 QR，用逗号分隔',
  inputHint: '用逗号（,）分隔，最多 10 个',
  inputEmptyError: '请至少输入一个值',
  maxInputError: '最多支持输入 10 个值',
  search: '查询',
  clear: '清空',
  found: '共 {y} 个，查到 {x} 个',
  clickTip: '点击图标查看详情',
  current: '当前',
  returns: '{n} 次退货',
  times: '{n} 次',
  visits: '{n} 次经过',
  records: '{n} 条记录',
  step: '第 {n} 步',
  latestFirst: '按时间倒序',
  relatedEpcs: '+{n} 个关联 EPC',
  main: '主',
  statusInvalidEpc: '非法 EPC',
  statusInvalidQr: '非法 QR Code',
  statusNoGlobalQr: '未找到对应的 Global QR',
  statusNoRecord: '无流转记录',
  noRecordTip: '没有查到流转记录',
  plantMismatch: '不在链路中',
  stage: {
    FACTORY: '工厂',
    DC: 'DC',
    RSC: 'RSC',
    CSC: 'CSC',
    CONSUMER: '消费者',
    CONSUMER_SCAN: '消费者扫码',
    RETURN_2C: '2C RW',
    TRANSHUB: 'Transhub',
    ADC: 'ADC',
    STORE: '门店',
    RETURN_2B: '2B RW',
    UNKNOWN: '未知'
  },
  dir: {
    ib: 'IB',
    ob: 'OB',
    cyclecount: '盘点',
    inbound: '入库',
    outbound: '出库',
    noRecord: '无 {dir} 记录'
  },
  legend: {
    title: '图例',
    stages: '环节',
    direction: 'IB / OB',
    actions: '操作',
    both: 'IB 和 OB 都有',
    ibOnly: '只有 IB',
    obOnly: '只有 OB',
    ioNote: '— 显示在 DC / RSC / CSC / 2C RW / 2B RW 下方'
  },
  event: {
    rework: '返工',
    reprint: '补打标签'
  },
  reworkType: {
    1: '实物少件',
    2: '实物多件',
    3: '特殊产品',
    4: '人工逐件扫描'
  },
  field: {
    qrCode: 'QR',
    upc: 'UPC',
    productCode: '产品编号',
    size: '尺码',
    time: '时间',
    operation: '操作',
    sourceEpc: '来源 EPC',
    stage: '环节',
    step: '步骤',
    actions: '返工 / 补打标签',
    createdBy: '创建方',
    country: '国家',
    code: '编码',
    eventId: '事件 ID',
    eventTime: '事件时间',
    plant: 'Plant',
    operationType: '操作类型',
    status: '状态',
    cartonNo: '箱号',
    tunnelId: '通道机编号',
    asnNo: 'ASN 号',
    factoryCode: '工厂代码',
    packlistNo: 'Packlist 单号',
    shipTo: 'Ship To',
    shipFrom: 'Ship From',
    platformOrderNo: '平台单号',
    trackingNo: '快递单号',
    store: '门店',
    type: '类型',
    shipFromStore: '发货门店',
    shipToStore: '收货门店',
    cscCode: 'CSC 代码',
    cscName: 'CSC 名称',
    orderNumber: '订单号',
    scanTime: '扫描时间',
    expressTrackingNumber: '快递单号',
    boxNumber: '箱号（Box）',
    rso: 'RSO',
    returnValidation: '退货校验结果',
    matchedBy: '匹配方式',
    reworkType: '返工类型',
    epcs: 'EPC 列表'
  },
  hero: {
    title1: 'Trace',
    title2: 'every',
    title3: 'tag.',
    title4: 'Factory',
    title5: 'to feet.'
  },
  kpi: {
    found: '已找到 EPC',
    stages: '环节',
    returns: '退货',
    rework: '返工',
    reprint: '补打标签'
  }
}
